export const SET_PROMO_CODE = 'SET_PROMO_CODE'
export const API_PROMO_CODES_APPLY_START = 'API_PROMO_CODES_APPLY_START'
export const API_PROMO_CODES_APPLY_SUCCESS = 'API_PROMO_CODES_APPLY_SUCCESS'
export const API_PROMO_CODES_APPLY_FAILURE = 'API_PROMO_CODES_APPLY_FAILURE'
export const API_PROMO_CODES_INFO_START = 'API_PROMO_CODES_INFO_START'
export const API_PROMO_CODES_INFO_SUCCESS = 'API_PROMO_CODES_INFO_SUCCESS'
export const API_PROMO_CODES_INFO_FAILURE = 'API_PROMO_CODES_INFO_FAILURE'
export const SET_PROMO_CODE_REFUSAL = 'SET_PROMO_CODE_REFUSAL'
export const SET_CREDIT_PREVIEW = 'SET_CREDIT_PREVIEW'
